const base_URL = window.API_URL;
const github_base_URL = window.GITHUB_API_URL;

// Kunal's Machine
// const base_URL = "http://10.10.149.35:8080/webKernel/active/cardano";

export const getGithubResource = ({
  endpoint,
  data,
  baseURL = github_base_URL,
  contentType = "application/json",
}: {
  endpoint: string;
  data?: any;
  baseURL?: string;
  contentType?: string;
}) => {
  const options = {
    method: "GET",
    mode: "cors" as RequestMode,
    headers: {
      "Content-Type": contentType,
    },
  };

  const url = data
    ? `${baseURL}/${endpoint}/${new URLSearchParams(data).toString()}`
    : `${baseURL}/${endpoint}`;

  return fetch(url, options)
    .then((response) => parseResponse(response))
    .catch((error) => {
      console.error("error");
      return error;
    });
};

export const getResource = ({
  endpoint,
  data = {},
  baseURL = base_URL,
  contentType = "application/x-www-form-urlencoded",
}: {
  endpoint: string;
  data?: any;
  baseURL?: string;
  contentType?: string;
}) => {
  const body = {
    ...data,
    action: "search",
  };
  const options = {
    method: "POST",
    mode: "cors" as RequestMode,
    headers: {
      "Content-Type": contentType,
    },
    body: new URLSearchParams(body),
  };

  return fetch(`${baseURL}/${endpoint}`, options)
    .then((response) => parseResponse(response))
    .catch((error) => {
      console.error("error");
      return error;
    });
};

const parseResponse = async (response: any) => {
  let result = null;
  const text = await response.text();
  try {
    const json = JSON.parse(text);
    // //console.log("parsed as json");
    result = json;
  } catch (err) {
    // //console.log("parsed as text");
    result = text;
  }
  if (response.ok) {
    return { error: null, response: result, code: response.status };
  } else {
    // //console.log("response")
    return { error: result, response: null, code: response.status };
  }
};
